import { render, staticRenderFns } from "./TerminateAutomation.vue?vue&type=template&id=08385de6"
import script from "./TerminateAutomation.vue?vue&type=script&lang=js"
export * from "./TerminateAutomation.vue?vue&type=script&lang=js"
import style0 from "./TerminateAutomation.vue?vue&type=style&index=0&id=08385de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports